import { FC } from 'react';
import { clsx } from '@team/clsx';
import { Text } from '../text';
import { Type } from './enums';
import { Props } from './types';
import css from './style.module.css';

const cssTypeMap: Record<Type, string> = {
  [Type.CAPTION_1]: css.captionL1,
  [Type.CAPTION_2]: css.captionL2,
  [Type.SUBHEADLINE_1]: css.subheadlineL1,
  [Type.SUBHEADLINE_2]: css.subheadlineL2,
  [Type.TEXT]: css.text,
  [Type.HEADLINE]: css.headline,
  [Type.TITLE_1]: css.titleL1,
  [Type.TITLE_2]: css.titleL2,
  [Type.TITLE_3]: css.titleL3,
};

/**
 * @todo подумать в сторону приятного интерфейса относительно type и level
 */
export const Layout: FC<Props> = ({ className, type, width, borderRadius }) => (
  <Text
    className={clsx(className, cssTypeMap[type])}
    width={width}
    borderRadius={borderRadius}
  />
);
